import React from "react";
import ReCAPTCHA from "react-google-recaptcha";
import "./recaptchaField.scss";

export const REQUIRED_RECAPTCHA_MESSAGE = "Please complete the CAPTCHA.";
export const EXPIRED_RECAPTCHA_MESSAGE =
  "CAPTCHA expired. Please complete it again.";
export const LOAD_FAILED_RECAPTCHA_MESSAGE =
  "CAPTCHA failed to load. Please try again.";

function RecaptchaField({
  recaptchaRef,
  onChange,
  onExpired,
  onErrored,
  error,
}) {
  const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

  return (
    <div className="recaptcha-field">
      {siteKey ? (
        <ReCAPTCHA
          ref={recaptchaRef}
          sitekey={siteKey}
          onChange={(token) => onChange?.(token || "")}
          onExpired={() => {
            onChange?.("");
            onExpired?.();
          }}
          onErrored={() => {
            onChange?.("");
            onErrored?.();
          }}
        />
      ) : (
        <span className="text-danger">
          reCAPTCHA is not configured. Set REACT_APP_RECAPTCHA_SITE_KEY.
        </span>
      )}
      {error ? (
        <div className="input-error">
          <span className="mb-0 text-danger">{error}</span>
        </div>
      ) : null}
    </div>
  );
}

export default RecaptchaField;
